import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, NumericTextBox, Checkbox } from "@progress/kendo-react-inputs";


export const NewForm = props => {

    return <Dialog title={`New User `} onClose={props.cancelNew}>
        <Form onSubmit={props.onSubmit} initialValues={props.item} render={formRenderProps => <FormElement style={{
            maxWidth: 650
        }}>
            <fieldset className={"k-form-fieldset"}>
                <div className="mb-3">
                    <Field
                        name={"username"}
                        id={"username"}
                        component={Input}
                        label={"Active Directory Username"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"emailAddress"}
                        id={"emailAddress"}
                        component={Input}
                        label={"Email Address"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"allowUserManage"}
                        id={"allowUserManage"}
                        component={Checkbox}
                        label={"Allow Manage Users"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"allowFileManage"}
                        id={"allowFileManage"}
                        component={Checkbox}
                        label={"Allow Manage Files"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"allowRecordingManage"}
                        id={"allowRecordingManage"}
                        component={Checkbox}
                        label={"Allow Manage Messages"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"allowRoutingManage"}
                        id={"allowRoutingManage"}
                        component={Checkbox}
                        label={"Allow Manage Routes"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"allowExtensionRights1"}
                        id={"allowExtensionRights1"}
                        component={Checkbox}
                        label={"Dashboard Only User"}
                    />
                </div>
                <div className="mb-3">
                    <p></p>
                </div>
            </fieldset>
            <div className="k-form-buttons">
                <button type={"submit"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" disabled={!formRenderProps.allowSubmit}>
                    Update
                </button>
                <button type={"submit"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={props.cancelNew}>
                    Cancel
                </button>
            </div>
        </FormElement>} />
    </Dialog>;
}; 